import { Heading } from "@chakra-ui/react";

export default function H3({ children, ...rest }) {
  return (
    <Heading
      as="h3"
      fontWeight="bold"
      fontSize="1.6rem"
      lineHeight="1.25"
      letterSpacing="0.3px"
      {...rest}
    >
      {children}
    </Heading>
  );
}
